import * as wasm from "./candid_parse_bg.wasm";
import { __wbg_set_wasm } from "./candid_parse_bg.js";
__wbg_set_wasm(wasm);
export * from "./candid_parse_bg.js";
